export default "__VITE_ASSET__CY4Ub7um__"